import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App.jsx';
import { queryClient } from './api/queryClient.js';
import { initSentry } from './lib/sentry.js';
import { logger } from './lib/logger.js';
import ErrorFallback from './components/ErrorBoundary/ErrorFallback.jsx';
import { ToastProvider } from './components/ui';
import './styles/global.css';

initSentry();

logger.info('app-boot', { product: 'Banyan AI Portal' });
logger.info('build-info', {
  buildTime: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : 'dev',
  version: typeof __BUILD_VERSION__ !== 'undefined' ? __BUILD_VERSION__ : 'dev',
});

// React Query Devtools — dynamic import so the prod bundle tree-shakes them
// out via Vite's `import.meta.env.PROD` static analysis. Phase 4 will verify
// in the bundle visualizer that no devtools code ships to production.
const Devtools = !import.meta.env.PROD
  ? React.lazy(() =>
      import('@tanstack/react-query-devtools').then((m) => ({
        default: m.ReactQueryDevtools,
      })),
    )
  : null;

function RootErrorFallback(props) {
  return <ErrorFallback {...props} variant="root" userId={undefined} />;
}

function onRootError(error) {
  logger.error('react-error-boundary-root', { error, route: window.location.pathname });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={RootErrorFallback} onError={onRootError}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <App />
          {Devtools ? (
            <React.Suspense fallback={null}>
              <Devtools initialIsOpen={false} buttonPosition="bottom-left" />
            </React.Suspense>
          ) : null}
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
